import { createSelector } from '@ngrx/store';

import type { ID } from '@recruitee/ngrx';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

import type { AvailableFlowsEntity } from './available-flows.types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<AvailableFlowsEntity>()('RequisitionsAvailableFlows', {});

const assigned = memoizeSelector((id: ID) =>
  createSelector(selectors.byId(id), entity => entity?.approvalFlows.find(flow => !!flow.assigned)),
);

const AvailableFlowsSelectors = {
  ...selectors,
  assigned,
};

export {
  AvailableFlowsSelectors,
  actions as AvailableFlowsActions,
  reducer as AvailableFlowsReducer,
  namespace as AvailableFlowsNamespace,
};
